var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useEffect, useState } from 'react';
import appService from '../api/app.service';
import { ApplePayVersion } from '../constants';
import { setAxiosGlobalHeaders } from '../api/httpClient';
import { getApplePayPaymentMethod, getApplePayRequest, validateCurrency, validateSupportedNetworks } from '../utils/config';
import { getMerchantCapaplities } from '../utils/defaultValues';
export var useApplePay = function (_a) {
    var publicKey = _a.publicKey, merchant = _a.merchant, transaction = _a.transaction, interfaceObj = _a.interface, customer = _a.customer, onCancel = _a.onCancel, onError = _a.onError, onSuccess = _a.onSuccess, scope = _a.scope, acceptance = _a.acceptance, features = _a.features, metaData = _a.metaData, debug = _a.debug, environment = _a.environment, platform = _a.platform, onReady = _a.onReady, onMerchantValidation = _a.onMerchantValidation, onShippingMethodSelected = _a.onShippingMethodSelected, onShippingContactSelected = _a.onShippingContactSelected, onPaymentMethodSelected = _a.onPaymentMethodSelected, onCouponChanged = _a.onCouponChanged;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), profileData = _c[0], setProfile = _c[1];
    var _d = useState(false), disabled = _d[0], setDisabled = _d[1];
    var _e = useState(undefined), applePaySession = _e[0], setApplePaySession = _e[1];
    var abortApplePaySession = useCallback(function () {
        applePaySession === null || applePaySession === void 0 ? void 0 : applePaySession.abort();
    }, [applePaySession]);
    var initialize = useCallback(function (metaData) { return __awaiter(void 0, void 0, void 0, function () {
        var merchantProfile, payment_options, headers, data, err_1;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    setLoading(true);
                    appService.setEnv(environment);
                    appService.setBaseUrl();
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 4, 5, 6]);
                    if (metaData) {
                        merchantProfile = metaData.merchant, payment_options = metaData.payment_options, headers = metaData.headers;
                        setAxiosGlobalHeaders(__assign({}, headers));
                        setProfile({ merchant: merchantProfile, payment_options: payment_options });
                        return [2];
                    }
                    return [4, appService.setBrowserHeaders({
                            locale: interfaceObj === null || interfaceObj === void 0 ? void 0 : interfaceObj.locale,
                            domain: merchant.domain,
                            pk: publicKey
                        })];
                case 2:
                    _h.sent();
                    return [4, appService.checkoutProfile({
                            currency: transaction.currency,
                            merchant_id: merchant.id,
                            total_amount: Number(transaction.amount),
                            order: __assign(__assign({ amount: Number(transaction.amount), currency: transaction.currency }, (customer && {
                                customer: {
                                    id: customer.id,
                                    email: (_a = customer.contact) === null || _a === void 0 ? void 0 : _a.email,
                                    first_name: ((_b = customer.name) === null || _b === void 0 ? void 0 : _b.length) ? customer.name[0].first : '',
                                    last_name: ((_c = customer.name) === null || _c === void 0 ? void 0 : _c.length) ? customer.name[0].last : '',
                                    phone: {
                                        country_code: ((_e = (_d = customer.contact) === null || _d === void 0 ? void 0 : _d.phone) === null || _e === void 0 ? void 0 : _e.countryCode) || '',
                                        number: ((_g = (_f = customer.contact) === null || _f === void 0 ? void 0 : _f.phone) === null || _g === void 0 ? void 0 : _g.number) || ''
                                    }
                                }
                            })), { merchant: {
                                    id: merchant.id
                                }, items: [
                                    {
                                        amount: Number(transaction.amount),
                                        currency: transaction.currency,
                                        name: 'apple pay sdk order item',
                                        quantity: 1,
                                        requiresShipping: 'no'
                                    }
                                ] }),
                            platform: platform
                        })];
                case 3:
                    data = _h.sent();
                    if (debug)
                        console.log('merchant configuration: ', data);
                    setProfile(data);
                    return [3, 6];
                case 4:
                    err_1 = _h.sent();
                    onError && onError(err_1.errors || err_1);
                    return [3, 6];
                case 5:
                    setLoading(false);
                    onReady && onReady();
                    return [7];
                case 6: return [2];
            }
        });
    }); }, [environment, interfaceObj === null || interfaceObj === void 0 ? void 0 : interfaceObj.locale, merchant.domain, publicKey, debug, onError]);
    useEffect(function () {
        initialize(metaData);
    }, [initialize, metaData]);
    var onApplePayButtonClicked = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ApplePaySession, paymentMethod, currency, cardBrands, request, session_1;
        var _a;
        return __generator(this, function (_b) {
            ApplePaySession = window.ApplePaySession;
            if (!ApplePaySession) {
                setDisabled(true);
                console.error('ApplePaySession is not available, please check if you are using Safari browser');
                return [2];
            }
            if (!profileData) {
                setDisabled(true);
                console.error('The profile data is not available, please check networks and try again');
                return [2];
            }
            try {
                paymentMethod = getApplePayPaymentMethod(profileData.payment_options.payment_methods || []);
                currency = validateCurrency(transaction.currency, paymentMethod.supported_currencies);
                cardBrands = validateSupportedNetworks(paymentMethod.supported_card_brands, acceptance === null || acceptance === void 0 ? void 0 : acceptance.supportedBrands);
                request = getApplePayRequest({
                    features: features,
                    countryCode: profileData.merchant.country_code,
                    transaction: __assign(__assign({}, transaction), { currency: currency }),
                    customer: customer,
                    supportedNetworks: cardBrands,
                    merchantCapabilities: getMerchantCapaplities(acceptance === null || acceptance === void 0 ? void 0 : acceptance.supportedCards),
                    name: profileData.merchant.name
                });
                if (debug) {
                    console.info("Creating ApplePaySession with version: ".concat(ApplePayVersion, " and request: ").concat(JSON.stringify(request)));
                }
                session_1 = new ApplePaySession(ApplePayVersion, request);
                setApplePaySession(session_1);
                session_1.onvalidatemerchant = function (event) { return __awaiter(void 0, void 0, void 0, function () {
                    var merchantSession, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                onMerchantValidation === null || onMerchantValidation === void 0 ? void 0 : onMerchantValidation('initiated');
                                if (debug) {
                                    console.info('Creating merchant session and validating merchant session');
                                    console.info('onvalidatemerchant event', event);
                                }
                                setLoading(true);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                if (debug) {
                                    console.info("creating merchant session for merchantData: ".concat(JSON.stringify(profileData.merchant), " and validationURL: ").concat(event.validationURL, " and merchant.domain: ").concat(merchant.domain));
                                }
                                return [4, appService.appleSession(__assign(__assign({}, profileData.merchant), { id: merchant.id }), event.validationURL, merchant.domain, merchant.identifier || merchant.id)];
                            case 2:
                                merchantSession = _a.sent();
                                if (debug)
                                    console.info('merchantSession', merchantSession);
                                session_1.completeMerchantValidation(merchantSession);
                                onMerchantValidation === null || onMerchantValidation === void 0 ? void 0 : onMerchantValidation('completed');
                                if (debug)
                                    console.info('merchantSession completed successfully!');
                                return [3, 4];
                            case 3:
                                error_1 = _a.sent();
                                setLoading(false);
                                onMerchantValidation === null || onMerchantValidation === void 0 ? void 0 : onMerchantValidation('error');
                                if (debug)
                                    console.error('error in onvalidatemerchant', error_1);
                                session_1.completePayment({ status: ApplePaySession.STATUS_FAILURE });
                                throw error_1;
                            case 4:
                                setLoading(false);
                                return [2];
                        }
                    });
                }); };
                session_1.onpaymentauthorized = function (event) { return __awaiter(void 0, void 0, void 0, function () {
                    var _a, token, rest, newEvent, _b, _c, paymentData, paymentMethod_1, transactionIdentifier, data, error_2;
                    var _d, _e;
                    return __generator(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                setLoading(true);
                                if (debug)
                                    console.info('onpaymentauthorized event', event);
                                _f.label = 1;
                            case 1:
                                _f.trys.push([1, 9, 10, 11]);
                                _a = (_d = event.payment) !== null && _d !== void 0 ? _d : {}, token = _a.token, rest = __rest(_a, ["token"]);
                                newEvent = { payment: rest };
                                _b = scope;
                                switch (_b) {
                                    case 'AppleToken': return [3, 2];
                                    case 'TapToken': return [3, 4];
                                }
                                return [3, 7];
                            case 2: return [4, (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(event.payment.token, newEvent))];
                            case 3:
                                _f.sent();
                                session_1.completePayment({ status: ApplePaySession.STATUS_SUCCESS });
                                return [3, 8];
                            case 4:
                                _c = (_e = event.payment.token) !== null && _e !== void 0 ? _e : {}, paymentData = _c.paymentData, paymentMethod_1 = _c.paymentMethod, transactionIdentifier = _c.transactionIdentifier;
                                return [4, appService.tapTokenization(__assign(__assign({}, paymentData), { paymentMethod: paymentMethod_1, transactionIdentifier: transactionIdentifier }))];
                            case 5:
                                data = _f.sent();
                                return [4, (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data, newEvent))];
                            case 6:
                                _f.sent();
                                session_1.completePayment({ status: ApplePaySession.STATUS_SUCCESS });
                                return [3, 8];
                            case 7:
                                console.error('We only support AppleToken and TapToken for now');
                                console.info('Completing payment with status: STATUS_FAILURE');
                                session_1.completePayment({ status: ApplePaySession.STATUS_FAILURE });
                                _f.label = 8;
                            case 8: return [3, 11];
                            case 9:
                                error_2 = _f.sent();
                                if (debug)
                                    console.error('error in onpaymentauthorized', error_2);
                                session_1.completePayment({ status: ApplePaySession.STATUS_FAILURE });
                                throw error_2;
                            case 10:
                                setLoading(false);
                                return [7];
                            case 11: return [2];
                        }
                    });
                }); };
                if (onShippingContactSelected) {
                    session_1.onshippingcontactselected = function (_a) {
                        var shippingContact = _a.shippingContact;
                        return __awaiter(void 0, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4, onShippingContactSelected(shippingContact)];
                                    case 1:
                                        response = _b.sent();
                                        if (response) {
                                            session_1.completeShippingContactSelection(response);
                                        }
                                        return [2];
                                }
                            });
                        });
                    };
                }
                if (onShippingMethodSelected) {
                    session_1.onshippingmethodselected = function (_a) {
                        var shippingMethod = _a.shippingMethod;
                        return __awaiter(void 0, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4, onShippingMethodSelected(shippingMethod)];
                                    case 1:
                                        response = _b.sent();
                                        if (response) {
                                            session_1.completeShippingMethodSelection(response);
                                        }
                                        return [2];
                                }
                            });
                        });
                    };
                }
                if (onPaymentMethodSelected) {
                    session_1.onpaymentmethodselected = function (_a) {
                        var paymentMethod = _a.paymentMethod;
                        return __awaiter(void 0, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4, onPaymentMethodSelected(paymentMethod)];
                                    case 1:
                                        response = _b.sent();
                                        if (response) {
                                            session_1.completePaymentMethodSelection(response);
                                        }
                                        return [2];
                                }
                            });
                        });
                    };
                }
                if (onCouponChanged) {
                    session_1.oncouponcodechanged = function (_a) {
                        var couponCode = _a.couponCode;
                        return __awaiter(void 0, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4, onCouponChanged(couponCode)];
                                    case 1:
                                        response = _b.sent();
                                        if (response) {
                                            session_1.completeCouponCodeChange(response);
                                        }
                                        return [2];
                                }
                            });
                        });
                    };
                }
                session_1.oncancel = function (event) {
                    console.info('oncancel event', event);
                    if (onCancel)
                        onCancel();
                };
                session_1.begin();
            }
            catch (e) {
                if (!onError)
                    return [2];
                if (e.errors) {
                    onError(e.errors);
                    return [2];
                }
                if ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data.errors) {
                    onError(e.response.data.errors);
                    return [2];
                }
                if (e.message) {
                    onError([{ description: e.message, code: '400' }]);
                    return [2];
                }
                onError(e);
            }
            return [2];
        });
    }); };
    return {
        loading: loading,
        disabled: !profileData || disabled,
        onApplePayButtonClicked: onApplePayButtonClicked,
        abortApplePaySession: abortApplePaySession
    };
};
